'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var $header = $('.sticky-header');
    $header.stick_in_parent({
        parent: 'body'
    });

    var $collectionNav = $('.sticky-nav');
    var sticknav = function sticknav(offset) {
        $collectionNav.trigger('sticky_kit:detach').stick_in_parent({
            offset_top: offset
        });
    };

    sticknav($header.height());

    $(window).resize(function () {
        var offset = $header.height();
        sticknav(offset);
    });
};

require('../../../node_modules/sticky-kit/dist/sticky-kit');